import * as z from 'zod';

export const TeamSeasonStatsSchema = z.object({
  gamesPlayed: z.number(),
  winRate: z.number(),
  possession: z.number(),
  totalGoals: z.number(),
  goalsScored: z.number(),
  goalsConceded: z.number(),
  over15Goals: z.number(),
  over25Goals: z.number(),
  over05GoalsHT: z.number(),
  over15GoalsHT: z.number(),
  shotsPerGame: z.number(),
  shotsOnTarget: z.number(),
  shotsOffTarget: z.number(),
  shotsConcededOnTarget: z.number(),
  shotsConcededOffTarget: z.number(),
  yellowCards: z.number(),
  redCards: z.number(),
  freeKicks: z.number(),
  corners: z.number(),
  fouls: z.number(),
});

const SeasonStatisticsSchema = z.object({
  prevYear: z.number().nullable(),
  currentYear: z.number(),
  leagueName: z.string().nullable(),
  home: TeamSeasonStatsSchema,
  away: TeamSeasonStatsSchema,
});

export default SeasonStatisticsSchema;
